import Config from '@config';
import { initializeEquipmentGroupApi } from '@gasbi/shared/common/features/equipmentGroup';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  equipmentGroupApi,
  useCreateEquipmentGroupMutation,
  useUpdateEquipmentGroupMutation,
  useGetEquipmentGroupsIInfiniteQuery,
} = initializeEquipmentGroupApi(Config.VITE_API_URL, axiosBaseQuery);
